import * as mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'

import list from '@/store/shared/selectableList'
import search from '@/store/shared/search'
import imported from './imported'

export default {
  namespaced: true,
  state () {
    return {
      id: undefined,
      from: undefined,
      to: undefined,
      invoiceId: undefined,
      serie: undefined,
      number: undefined,
      documentProvider: undefined,
      documentClient: undefined,
      amount: undefined,
      status: -1,
      type: undefined,
      loaded: false,
      delegation: undefined,
      newStatus: undefined
    }
  },
  mutations,
  actions,
  getters,
  modules: {
    list,
    search,
    imported
  }
}
